import { Dialog } from "@headlessui/react";
import { ModalFoterBox } from "../../components/box/Box";
import Button from "../../components/button/Button";
import { Modal, ModalProp } from "../../components/modal/Modal";
import { alertOpen, AlertValue } from "../../features/alert.slice";
import userQuery from "../../firestore/User.query";
import { useDispatch } from "react-redux";
import { insertMessageAttendance, MessageAttendanceList } from "../../model/Message";

export type ParticipantDeleteModalProps = {
  tenantId: string;
  messageId: string;
  isStaffConfirmed: boolean;
  userData: MessageAttendanceList | null;
  deleteUserList: MessageAttendanceList[];
  setDeleteUserList: React.Dispatch<React.SetStateAction<MessageAttendanceList[]>>;
}

export const ParticipantDeleteModal = ({
  open,
  toggle,
  closeOnClickOutside,
  tenantId,
  messageId,
  isStaffConfirmed,
  userData,
  deleteUserList,
  setDeleteUserList
}: ModalProp & ParticipantDeleteModalProps) => {
  const dispatch = useDispatch();

  const handle = async () => {
    try{
      if (userData !== null) {
        if(isStaffConfirmed){
          await userQuery.deleteEventParticipationHistory(userData.userId, messageId);
        }
        await userQuery.deleteReadMessage(tenantId, userData.userId, messageId);
        setDeleteUserList(insertMessageAttendance(deleteUserList, userData))
        toggle();
        dispatch(alertOpen(AlertValue(`参加した利用者を取り消しました。利用者番号：${userData.displayId}　利用者名：${userData.lastName}`, "success")));
      }
    }catch{
      dispatch(alertOpen(AlertValue("取消時にエラーが発生しました。", "danger")));
    }
  };

  return (
    <Modal
      open={open}
      toggle={toggle}
      closeOnClickOutside={closeOnClickOutside}
    >
      <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all">
        <div className="px-2 pb-4 sm:p-4">
          <div className="text-center sm:mt-3">
            <Dialog.Title
              as="h3"
              className="text-left text-lg font-medium leading-6 text-gray-900"
            >
              {userData?.lastName}
            </Dialog.Title>
          </div>
          <div className="mt-5">
            本当に取消しますか？
          </div>
        </div>
        <ModalFoterBox>
          <Button
            className="mx-2 mt-1 w-[132px]"
            outline
            onClick={toggle}
            children={"キャンセル"}
          />
          <Button
            className="mt-1 mr-2 w-[132px]"
            color="red"
            onClick={() => handle()}
            children={"取消"}
          />
        </ModalFoterBox>
      </Dialog.Panel>
    </Modal>
  );
};